var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1733 14.8334H5.82665C2.55332 14.8334 1.15332 13.4334 1.15332 10.1601V10.0734C1.15332 7.11343 2.31999 5.68677 4.93332 5.4401C5.19999 5.4201 5.45332 5.6201 5.47999 5.89343C5.50665 6.16677 5.30665 6.41343 5.02665 6.4401C2.93332 6.63343 2.15332 7.6201 2.15332 10.0801V10.1668C2.15332 12.8801 3.11332 13.8401 5.82665 13.8401H10.1733C12.8867 13.8401 13.8467 12.8801 13.8467 10.1668V10.0801C13.8467 7.60677 13.0533 6.6201 10.92 6.4401C10.6467 6.41343 10.44 6.17343 10.4667 5.9001C10.4933 5.62677 10.7267 5.4201 11.0067 5.44677C13.66 5.67343 14.8467 7.10677 14.8467 10.0868V10.1734C14.8467 13.4334 13.4467 14.8334 10.1733 14.8334Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.4199C7.72667 10.4199 7.5 10.1933 7.5 9.91992V1.33325C7.5 1.05992 7.72667 0.833252 8 0.833252C8.27333 0.833252 8.5 1.05992 8.5 1.33325V9.91992C8.5 10.1999 8.27333 10.4199 8 10.4199Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.1667C7.87331 11.1667 7.74664 11.1201 7.64664 11.0201L5.41331 8.78673C5.21998 8.59339 5.21998 8.27339 5.41331 8.08006C5.60664 7.88673 5.92664 7.88673 6.11998 8.08006L7.99998 9.96006L9.87998 8.08006C10.0733 7.88673 10.3933 7.88673 10.5866 8.08006C10.78 8.27339 10.78 8.59339 10.5866 8.78673L8.35331 11.0201C8.25331 11.1201 8.12664 11.1667 7.99998 11.1667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.17bd37fffc7b52cd59d64d4bae47f55a.svg";
export { ForwardRef as ReactComponent };